// Rol «Administrador Integral»: una sola persona que recorre todo el flujo de
// solicitudes de gasto (solicita, aprueba, compra, entrega y confirma) sin
// cambiar de cuenta. Se crea en el backend con la migración
// create_admin_integral_role y se asigna a mano desde Usuarios.
//
// Las pantallas del flujo deciden qué botón dibujar comparando el NOMBRE del
// rol; este helper concentra esa comparación para el rol integral. Quien lo
// tiene cuenta como administrador (aprueba) y como comprador (Caja chica /
// Adquisiciones: método de pago, confirmar entrega, devoluciones).
export const WORKFLOW_ROLE = 'admin_integral';

export const isWorkflowRole = (roleName) => roleName === WORKFLOW_ROLE;
